"use strict";

import angular from "angular";
import _ from "lodash";
import "./themes/apply-licenses-dialog.scss";
import "./themes/apply-licenses-dialog-dark.scss";

class ApplyLicensesDialogCtrl {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }

    $onInit() {}
}

ApplyLicensesDialogCtrl.$inject = ["$mdDialog", "locals"];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("ApplyLicensesDialogCtrl", ApplyLicensesDialogCtrl);
